import { render, staticRenderFns } from "./DevicePieChart.vue?vue&type=template&id=bca76d4e&scoped=true&"
import script from "./DevicePieChart.vue?vue&type=script&lang=js&"
export * from "./DevicePieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca76d4e",
  null
  
)

export default component.exports